/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconApple = createReactComponent("outline", "apple", "IconApple", [["path", { "d": "M4 11.319c0 3.102 .444 5.319 2.222 7.978c1.351 1.797 3.156 2.247 5.08 .988c.426 -.268 .97 -.268 1.397 0c1.923 1.26 3.728 .809 5.079 -.988c1.778 -2.66 2.222 -4.876 2.222 -7.977c0 -2.661 -1.99 -5.32 -4.444 -5.32c-1.267 0 -2.41 .693 -3.22 1.44a.5 .5 0 0 1 -.672 0c-.809 -.746 -1.953 -1.44 -3.22 -1.44c-2.454 0 -4.444 2.66 -4.444 5.319", "key": "svg-0" }], ["path", { "d": "M7 12c0 -1.47 .454 -2.34 1.5 -3", "key": "svg-1" }], ["path", { "d": "M12 7c0 -1.2 .867 -4 3 -4", "key": "svg-2" }]]);

export { IconApple as default };
//# sourceMappingURL=IconApple.mjs.map
